import { UserInfo } from 'api/endpoints';
import { IOption } from 'components/UIComponents/MultiSelect';

export const mapUserInfoToOption = (
  user: Pick<UserInfo, 'id' | 'firstName' | 'lastName'>,
): IOption => ({
  label: `${user.firstName} ${user.lastName}`,
  value: `${user.id}`,
});
